import { SourcesButton } from 'ai-components-ui-library/components/buttons/SourcesButton';
import { BlogIcon, FileIcon, KnowledgeBaseIcon, WebsiteIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useState } from 'react';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { trackEvent } from '../../../../usage-tracking/clients/usageTracker';
import { getViewCitationList } from '../../events/ReplyRecommendationCitationEvents';
import { ReplyRecommendationCitationPopoverContent } from './ReplyRecommendationCitationPopoverContent';
import { jsx as _jsx } from "react/jsx-runtime";
const getCitationSourceIcon = ({
  hubSpotContentType
}) => {
  if (hubSpotContentType === 'BLOG_POST') {
    return BlogIcon;
  }
  if (hubSpotContentType === 'KB_ARTICLE') {
    return KnowledgeBaseIcon;
  }
  if (hubSpotContentType === 'HS_WEB_PAGE') {
    return WebsiteIcon;
  }
  return FileIcon;
};
export const ReplyRecommendationCitationsButton = ({
  citationsList
}) => {
  const [popoverState, setPopoverState] = useState(false);
  const handleOpenChange = ({
    target: {
      value
    }
  }) => {
    setPopoverState(value);
  };
  return /*#__PURE__*/_jsx(Popover, {
    open: popoverState,
    onOpenChange: handleOpenChange,
    showCloseButton: true,
    content: /*#__PURE__*/_jsx(ReplyRecommendationCitationPopoverContent, {
      citationsList: citationsList
    }),
    children: /*#__PURE__*/_jsx(SourcesButton, {
      count: citationsList.length,
      icons: citationsList.map(citation => /*#__PURE__*/_jsx(IconHolder, {
        icon: getCitationSourceIcon({
          hubSpotContentType: readUnhandledEnumCase(citation.hubSpotContentType)
        }),
        color: "icon-core-on-fill-default",
        backgroundColor: "fill-primary-default"
      }, citation.citationId)),
      onClick: () => {
        setPopoverState(!popoverState);
        trackEvent(getViewCitationList());
      }
    })
  });
};
ReplyRecommendationCitationsButton.displayName = 'ReplyRecommendationCitationsButton';